
import { Component, Emit, Vue } from 'vue-property-decorator';
@Component({})
export default class ZawaSuspended extends Vue {
  @Emit('onLoginWithProvider') onLoginWithProvider(id: string) {}
}
